import vContent from "./v-content.vue";

export default Vue => {
  Vue.component("v-content", vContent);
};
